module.exports = __webpack_public_path__ + "img/loading-logo.20fa4019.svg";